import { render, staticRenderFns } from "./Goodsonline.vue?vue&type=template&id=54aad782&scoped=true&"
import script from "./Goodsonline.vue?vue&type=script&lang=js&"
export * from "./Goodsonline.vue?vue&type=script&lang=js&"
import style0 from "./Goodsonline.vue?vue&type=style&index=0&id=54aad782&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aad782",
  null
  
)

export default component.exports